module.exports = __webpack_public_path__ + "img/onlinePharmacy.303971a4.png";